(() => {
  function init() {
    const nav = document.getElementById('kidshoe-main-navigation');
    if (!nav || nav.dataset.initialized) return;
    nav.dataset.initialized = 'true';
    const compact = window.matchMedia('(max-width:991px)');
    const toggles = [...document.querySelectorAll('[data-knav-toggle]')];
    const triggers = [...nav.querySelectorAll('.knav-trigger')];
    function closePanels() {
      triggers.forEach(t => { t.setAttribute('aria-expanded','false'); document.getElementById(t.getAttribute('aria-controls')).hidden = true; });
    }
    function closeMenu() {
      closePanels(); nav.dataset.mobileOpen = 'false';
      toggles.forEach(t => { t.setAttribute('aria-expanded','false'); t.setAttribute('aria-label','Open menu'); });
    }
    function openPanel(trigger) {
      closePanels();
      nav.style.setProperty('--knav-room', Math.max(180, window.innerHeight - nav.getBoundingClientRect().bottom - 12) + 'px');
      trigger.setAttribute('aria-expanded','true');
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      panel.hidden = false;
      if (panel.id === 'knav-shoes' || panel.id === 'knav-apparel') panel.querySelectorAll('.knav-group-toggle').forEach(b => {
        const expanded = /_(girls|boys)$/.test(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded',String(expanded));
        document.getElementById(b.getAttribute('aria-controls')).dataset.expanded = String(expanded);
      });
    }
    toggles.forEach(t => t.addEventListener('click', () => {
      const open = nav.dataset.mobileOpen !== 'true'; closePanels(); nav.dataset.mobileOpen = String(open);
      toggles.forEach(x => { x.setAttribute('aria-expanded',String(open)); x.setAttribute('aria-label',open?'Close menu':'Open menu'); });
      if (open) {
        const shoes = triggers.find(t => t.getAttribute('aria-controls') === 'knav-shoes');
        if (shoes) openPanel(shoes);
        nav.querySelector('.knav-top a')?.focus();
      }
    }));
    triggers.forEach(t => {
      t.addEventListener('click', () => t.getAttribute('aria-expanded') === 'true' ? closePanels() : openPanel(t));
      t.addEventListener('keydown', e => { if (e.key === 'ArrowDown') { e.preventDefault(); openPanel(t); document.getElementById(t.getAttribute('aria-controls')).querySelector('a')?.focus(); } });
    });
    nav.querySelectorAll('[data-knav-panel-close]').forEach(b => b.addEventListener('click', () => {
      const trigger = triggers.find(t => t.getAttribute('aria-controls') === b.closest('.knav-panel').id);
      closePanels(); trigger?.focus();
    }));
    nav.querySelectorAll('[data-knav-close]').forEach(b => b.addEventListener('click', () => { closeMenu(); toggles[0]?.focus(); }));
    nav.querySelectorAll('.knav-group-toggle').forEach(b => b.addEventListener('click', () => {
      const open = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded',String(open)); document.getElementById(b.getAttribute('aria-controls')).dataset.expanded = String(open);
    }));
    document.addEventListener('pointerdown', e => { if (!nav.contains(e.target) && !toggles.some(t => t.contains(e.target))) closeMenu(); });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      const active = triggers.find(t => t.getAttribute('aria-expanded') === 'true');
      if (active) { closePanels(); active.focus(); }
      else if (nav.dataset.mobileOpen === 'true') { closeMenu(); toggles[0]?.focus(); }
    });
    nav.addEventListener('focusout', () => setTimeout(() => { if (!compact.matches && !nav.contains(document.activeElement)) closePanels(); },0));
    compact.addEventListener('change', closeMenu);
    document.addEventListener('shopify:section:unload', closeMenu);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
